// Build a per-property search criterion for IncludedValueSearch.
// Inputs:
// - propertyPath: string path, e.g., 'a.b'
// - values: array of strings
// - includeUndefined: boolean
// Output shapes:
// - When includeUndefined === false:
//     { [propertyPath]: { $eq: true|false } }  // if single boolean token
//     { [propertyPath]: { $in: [..] } }        // for single non-boolean or multi values
// - When includeUndefined === true:
//     { $or: [ { [propertyPath]: { $eq: true|false | $in: [...] } }, { [propertyPath]: { $exists: false } } ] }
// - When no usable values: returns undefined

export default function buildIncludedValueCriterion(propertyPath, values, includeUndefined, filterWrapper = x => x) {
    if (!propertyPath) return undefined;
    const vals = Array.isArray(values)
        ? values.map(v => (v == null ? '' : `${v}`.trim())).filter(v => v.length > 0)
        : [];

    if (!vals.length) return undefined;

    // Determine the primary clause
    let primaryClause;
    if (vals.length === 1) {
        const lower = vals[0].toLowerCase();
        if (lower === 'true') {
            primaryClause = { [propertyPath]: { $eq: true } };
        } else if (lower === 'false') {
            primaryClause = { [propertyPath]: { $eq: false } };
        } else {
            primaryClause = { [propertyPath]: { $in: vals } };
        }
    } else {
        primaryClause = { [propertyPath]: { $in: vals } };
    }

    if (includeUndefined) {
        return filterWrapper({ $or: [primaryClause, { [propertyPath]: { $exists: false } }] });
    }
    // Return only the inner value clause for direct assignment
    return filterWrapper(primaryClause);
}
